
import { computed, defineComponent, ref, toRef, watch } from "vue";
import {
  DroppableComponent,
  transformToTableRow,
} from "../components/dynamicValidation";

import DrawComponent from "../components/DrawComponent.vue";
import { SectionDesignAPI } from "@/services/api/SectionDesign.service";
import { Actions } from "@/store/enums/StoreEnums";
import store from "@/store";
export interface SelectedDropElement {
  type: DroppableComponent;
  parentId: string;
}
export default defineComponent({
  name: "template-preview-modal",
  emits: ["update-data"],
  props: {
    sectionId: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  components: {
    DrawComponent,
  },
  setup(props, { emit }) {
    const sectionIdVal = toRef(props, "sectionId");
    const formStructureVal = ref<any>([]);
    const MAX_COLUMNS = 6;
    const MAX_BLOCKS = 60;

    const spanInColumn = computed(() => {
      return formStructureVal?.value?.map((row) =>
        row?.columns?.reduce((pre, curr) => +curr?.colSpan + +pre, 0)
      );
    });
    watch(
      sectionIdVal,
      async (newVal) => {
        formStructureVal.value = [];
        try {
          store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
          formStructureVal.value = transformToTableRow(
            await SectionDesignAPI.getInstance().getFormDesign(newVal + ""),
            newVal
          );
        } catch (e) {
          console.log("error", e);
        } finally {
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        }
      },
      { deep: true }
    );
    return {
      formStructureVal,
      MAX_COLUMNS,
      MAX_BLOCKS,
      spanInColumn,
    };
  },
});
